<template>
  <div>
    <h1>输入框keyup事件+click事件</h1>
    <p>不用表单，候选词按回车会触发搜索</p>
    <div class="d-flex align-center">
      <v-text-field
        v-model="value"
        label="请输入"
        dense
        outlined
        hide-details
        style="max-width: 200px;"
        class="mr-2"
        @keyup.enter="handleSubmit"
      />
      <v-btn
        class="mr-2"
        @click="handleSubmit"
      >
        查询
      </v-btn>
      <div>目前状态: {{ status }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      value: '',
      status: '输入中'
    }
  },
  methods: {
    handleSubmit() {
      this.status = '查询中' + this.value
      setTimeout(() => {
        this.status = '查询成功'
        setTimeout(() => {
          this.reset()
        }, 1000)
      }, 1000)
    },
    reset() {
      this.value = ''
      this.status = '输入中'
    }
  }
}
</script>

<style scoped>
</style>